(function () {
  const ADULT_Q = [
    { id: 'AQ1', question: "What's your age range?", options: ['18-25', '26-35', '36-45', '46-55', '55+'] },
    { id: 'AQ2', question: "What's your diet type?", options: ['Vegetarian', 'Vegan', 'Non-Veg', 'Flexitarian'] },
    { id: 'AQ3', question: 'How many hours of screen time daily?', options: ['<2', '2-4', '4-8', '8+'] },
    {
      id: 'AQ4',
      question: 'Do you experience any eye symptoms?',
      options: ['Eye strain', 'Dry eyes', 'Headaches', 'Blurry vision', 'None'],
      multiSelect: true,
    },
    { id: 'AQ5', question: 'How would you rate your stress?', options: ['Low', 'Moderate', 'High', 'Very High'] },
    {
      id: 'AQ6',
      question: 'Do you experience any of these?',
      options: ['Fatigue', 'Poor sleep', 'Anxiety', 'Difficulty focusing', 'Mood swings', 'None'],
      multiSelect: true,
    },
    { id: 'AQ7', question: 'How much sunlight do you get daily?', options: ['<15min', '15-30 min', '30-60 min', '1hr+'] },
    {
      id: 'AQ8',
      question: 'Any bone or joint concerns?',
      options: ['Joint pain', 'Weakness', 'Cramps', 'Slow healing', 'None'],
      multiSelect: true,
    },
    {
      id: 'AQ9',
      question: "What's your primary wellness goal?",
      options: ['Eye health', 'Stress relief', 'Stronger bones', 'Overall nutrition'],
    },
    { id: 'AQ10', question: 'How did you find us?', options: ['Instagram', 'Amazon', 'Friend', 'Google', 'Other'] },
  ];

  const KIDS_Q = [
    { id: 'KQ1', question: 'How old is your child?', options: ['4-6', '7-9', '10-12'] },
    {
      id: 'KQ2',
      question: "How are your child's eating habits?",
      options: ['Eats all', 'Somewhat picky', 'Very picky', 'Restricted diet'],
    },
    { id: 'KQ3', question: "What's your child's diet type?", options: ['Vegetarian', 'Non-Veg', 'Vegan'] },
    {
      id: 'KQ4',
      question: "How are your child's energy levels?",
      options: ['Always active', 'Sometimes tired', 'Often fatigued', 'Lethargic'],
    },
    {
      id: 'KQ5',
      question: 'Does your child show any of these?',
      options: ['Frequent infections', 'Pale skin', 'Hair fall', 'Brittle nails', 'None'],
      multiSelect: true,
    },
    {
      id: 'KQ6',
      question: "How is your child's focus and mood?",
      options: ['Focused & happy', 'Sometimes distracted', 'Often moody', 'Difficulty concentrating'],
    },
    { id: 'KQ7', question: 'How much daily screen time?', options: ['<1 hr', '1-2 hrs', '2-4 hrs', '4+ hrs'] },
    {
      id: 'KQ8',
      question: 'Any eye-related symptoms?',
      options: ['Eye rubbing', 'Squinting', 'Headaches', 'Sits too close to screens', 'None'],
      multiSelect: true,
    },
    {
      id: 'KQ9',
      question: 'How much outdoor play/sun?',
      options: ['Lots of outdoor time', 'Some', 'Very little', 'Mostly indoors'],
    },
    {
      id: 'KQ10',
      question: "What's your top concern for your child?",
      options: ['Immunity', 'Growth', 'Focus', 'Eye health', 'Overall nutrition'],
    },
  ];

  // Wheel: WELL20 / WELL15 / WELL10 / WELL5 with batch-style odds (5 / 15 / 30 / 50).
  const PRIZES = [
    { label: '20% OFF', percent: 20, emoji: '✨', code: 'WELL20', weight: 5 },
    { label: '15% OFF', percent: 15, emoji: '🌟', code: 'WELL15', weight: 15 },
    { label: '10% OFF', percent: 10, emoji: '🎉', code: 'WELL10', weight: 30 },
    { label: '5% OFF', percent: 5, emoji: '💚', code: 'WELL5', weight: 50 },
  ];
  const WHEEL_COLORS = [
    'hsl(276 28% 9%)',
    'hsl(167 19% 34%)',
    'hsl(169 17% 57%)',
    'hsl(167 19% 34%)',
  ];

  const ICONS = {
    check:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    chevronRight:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
    chevronLeft:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
    copy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="14" x="8" y="8" rx="2"/><path d="M4 16V4a2 2 0 0 1 2-2h12"/></svg>',
    user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
    baby: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12h.01"/><path d="M15 12h.01"/><path d="M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5"/><path d="M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1"/></svg>',
    activity:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"/></svg>',
  };

  const STORAGE_KEY = 'welloura.quizSubmissions.v1';

  function levelOf(score, max) {
    const n = score / max;
    if (n >= 0.6) return 'High';
    if (n >= 0.3) return 'Moderate';
    return 'Low';
  }

  function claimSpinPrize() {
    const total = PRIZES.reduce((sum, p) => sum + (p.weight || 0), 0) || PRIZES.length;
    let roll = Math.random() * total;
    let idx = PRIZES.length - 1;
    for (let i = 0; i < PRIZES.length; i++) {
      roll -= PRIZES[i].weight || 1;
      if (roll <= 0) {
        idx = i;
        break;
      }
    }
    const prize = PRIZES[idx];
    return {
      prizeIndex: idx,
      percent: prize.percent,
      label: prize.label,
      emoji: prize.emoji,
      code: prize.code,
    };
  }

  function saveSubmission(entry) {
    try {
      const id =
        (crypto && crypto.randomUUID && crypto.randomUUID()) ||
        `qs_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
      const row = { ...entry, id, createdAt: new Date().toISOString() };
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      list.unshift(row);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      return id;
    } catch (err) {
      console.error('Failed to save quiz submission', err);
      return null;
    }
  }

  function patchSubmission(id, patch) {
    if (!id) return;
    try {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      const i = list.findIndex((x) => x.id === id);
      if (i !== -1) {
        list[i] = { ...list[i], ...patch };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      }
    } catch (err) {
      /* ignore */
    }
  }

  function scoreAdult(answers, products, images) {
    let eye = 0;
    let stress = 0;
    let bone = 0;
    const screen = answers.AQ3;
    if (screen === '4-8') eye += 1;
    if (screen === '8+') eye += 2;
    const eyeSym = answers.AQ4 || [];
    if (!eyeSym.includes('None')) eye += eyeSym.length;
    const s = answers.AQ5;
    if (s === 'Moderate') stress += 1;
    if (s === 'High') stress += 2;
    if (s === 'Very High') stress += 3;
    const stressSym = answers.AQ6 || [];
    if (!stressSym.includes('None')) stress += stressSym.length;
    const sun = answers.AQ7;
    if (sun === '<15min') bone += 2;
    if (sun === '15-30 min') bone += 1;
    const boneSym = answers.AQ8 || [];
    if (!boneSym.includes('None')) bone += boneSym.length;

    const deficiencies = [
      {
        category: 'Eye Health',
        score: Math.min(eye, 6),
        maxScore: 6,
        level: levelOf(eye, 6),
        image: images.eye,
        color: 'hsl(172 17% 75%)',
        description:
          eye >= 4
            ? 'Significant screen-related eye strain detected. Lutein & Zeaxanthin supplementation strongly recommended.'
            : eye >= 2
              ? 'Moderate digital eye fatigue. Consider protective nutrients for long-term eye health.'
              : 'Your eyes seem well-supported. Maintain good screen habits.',
      },
      {
        category: 'Stress & Energy',
        score: Math.min(stress, 8),
        maxScore: 8,
        level: levelOf(stress, 8),
        image: images.stress,
        color: 'var(--ener)',
        description:
          stress >= 5
            ? 'High stress indicators detected. Adaptogenic support with Ashwagandha & B-Complex recommended.'
            : stress >= 3
              ? 'Moderate stress and fatigue signs. Nutritional support can help manage energy levels.'
              : 'Stress levels appear manageable. Keep up healthy habits.',
      },
      {
        category: 'Bone & Vitamin D',
        score: Math.min(bone, 7),
        maxScore: 7,
        level: levelOf(bone, 7),
        image: images.bone,
        color: 'var(--solas)',
        description:
          bone >= 4
            ? 'Low sun exposure and joint concerns indicate Vitamin D3+K2 deficiency risk.'
            : bone >= 2
              ? 'Some risk factors for Vitamin D insufficiency. Supplementation may help.'
              : 'Adequate sun exposure detected. Continue maintaining bone health.',
      },
    ];

    const recs = [];
    if (eye >= 3) recs.push(products.optix);
    if (stress >= 3) recs.push(products.ener);
    if (bone >= 3) recs.push(products.solas);
    if (recs.length === 0) {
      const goal = answers.AQ9;
      if (goal === 'Eye health') recs.push(products.optix);
      else if (goal === 'Stress relief') recs.push(products.ener);
      else if (goal === 'Stronger bones') recs.push(products.solas);
      else recs.push(products.optix, products.ener);
    }
    return { recs, deficiencies };
  }

  function scoreKids(answers, products, images) {
    let nutrition = 0;
    let eye = 0;
    const eat = answers.KQ2;
    if (eat === 'Somewhat picky') nutrition += 1;
    if (eat === 'Very picky' || eat === 'Restricted diet') nutrition += 2;
    const energy = answers.KQ4;
    if (energy === 'Sometimes tired') nutrition += 1;
    if (energy === 'Often fatigued' || energy === 'Lethargic') nutrition += 2;
    const gaps = answers.KQ5 || [];
    if (!gaps.includes('None')) nutrition += gaps.length;
    const screen = answers.KQ7;
    if (screen === '2-4 hrs') eye += 1;
    if (screen === '4+ hrs') eye += 2;
    const eyeSym = answers.KQ8 || [];
    if (!eyeSym.includes('None')) eye += eyeSym.length;

    const deficiencies = [
      {
        category: 'Nutritional Gaps',
        score: Math.min(nutrition, 7),
        maxScore: 7,
        level: levelOf(nutrition, 7),
        image: images.nutrition,
        color: 'hsl(167 19% 34%)',
        description:
          nutrition >= 4
            ? 'Significant nutritional gaps detected. A comprehensive multivitamin is strongly recommended.'
            : nutrition >= 2
              ? 'Some nutritional concerns. A daily multivitamin can help fill dietary gaps.'
              : 'Diet appears balanced. Continue encouraging variety.',
      },
      {
        category: 'Eye Health',
        score: Math.min(eye, 6),
        maxScore: 6,
        level: levelOf(eye, 6),
        image: images.eye,
        color: 'hsl(172 17% 75%)',
        description:
          eye >= 4
            ? 'High screen exposure with symptoms. Eye-protective nutrients recommended.'
            : eye >= 2
              ? 'Moderate screen time. Monitor for eye strain symptoms.'
              : 'Screen habits seem healthy. Keep encouraging outdoor play.',
      },
    ];
    const recs = [products.bloom];
    if (eye >= 3) recs.push(products.optix);
    return { recs, deficiencies };
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function productSale(p) {
    const priceCents = Number(p && p.price_cents) || 0;
    const mrpCents = Number(p && p.mrp_cents) || 0;
    const onSale = p && (p.on_sale === true || (mrpCents > priceCents && priceCents > 0));
    let discount = String((p && p.discount) || '').trim();
    if (onSale && !discount && mrpCents > 0) {
      discount = `${Math.round(((mrpCents - priceCents) / mrpCents) * 100)}% off`;
    }
    return {
      onSale: Boolean(onSale),
      priceLabel: (p && p.price) || '',
      mrpLabel: onSale && p && p.mrp ? p.mrp : '',
      discount: onSale ? discount : '',
    };
  }

  function initQuiz(root) {
    if (root.dataset.wlQuizReady) return;
    root.dataset.wlQuizReady = '1';
    const cfgEl = root.querySelector('[data-wl-quiz-config]');
    if (!cfgEl) return;
    const config = JSON.parse(cfgEl.textContent);
    const products = config.products;
    const images = config.assessments;
    const copy = config.copy || {};

    function t(key, fallback) {
      const v = copy[key];
      return v == null || String(v).trim() === '' ? fallback : String(v);
    }

    function withBrand(str) {
      return escapeHtml(str).replace(/Welloura/g, '<strong>Welloura</strong>');
    }

    function absUrl(path) {
      if (!path) return '';
      if (/^https?:\/\//i.test(path)) return path;
      const origin = (config.email && config.email.origin) || window.location.origin;
      return origin.replace(/\/$/, '') + (path.charAt(0) === '/' ? path : '/' + path);
    }

    function modeLabel(mode) {
      if (mode === 'kids') return t('kids_label', 'For My Child (4-14)') || 'For My Child';
      if (mode === 'both') return t('family_label', 'For the Whole Family') || 'Whole Family';
      return t('adult_label', 'For Me (Adult)') || 'Adult';
    }

    function answerLines() {
      const list = questions();
      const adultCount = ADULT_Q.length;
      return list
        .map((q, i) => {
          const val = state.answers[q.id];
          if (val == null || val === '') return '';
          const pretty = Array.isArray(val) ? val.join(', ') : String(val);
          const who =
            state.mode === 'both'
              ? q.id.indexOf('KQ') === 0 || i >= adultCount
                ? 'Child'
                : 'Adult'
              : '';
          const prefix = who ? `[${who}] ` : '';
          return `${prefix}${q.question}\n   ${pretty}`;
        })
        .filter(Boolean);
    }

    function buildEmailReport() {
      const { adultResult, kidsResult } = compute();
      const recs = [...new Map([...adultResult.recs, ...kidsResult.recs].map((p) => [p.id, p])).values()];
      const risks =
        state.mode === 'both'
          ? adultResult.deficiencies
              .map((d) => ({ ...d, who: t('section_you', 'You') }))
              .concat(kidsResult.deficiencies.map((d) => ({ ...d, who: t('section_child', 'Your Child') })))
          : adultResult.deficiencies.concat(kidsResult.deficiencies);
      const shop = (config.email && config.email.shop_name) || 'Welloura';
      const prize = state.prize;
      const riskText = risks
        .map((r) => {
          const who = r.who ? `${r.who} — ` : '';
          return `• ${who}${r.category}: ${r.level} Risk (${r.score}/${r.maxScore})\n  ${r.description}`;
        })
        .join('\n');
      const recText = recs
        .map((p) => {
          const sale = productSale(p);
          const pricePart = sale.mrpLabel ? `${sale.priceLabel} (MRP ${sale.mrpLabel})` : sale.priceLabel;
          const extra = pricePart ? `  ${pricePart}` : '';
          return `• ${p.brandName} — ${p.name.replace(/\n/g, ' ')}${extra}\n  ${absUrl(p.url)}`;
        })
        .join('\n');
      const prizeText = prize
        ? `${prize.label}`
        : 'Pending spin';
      const couponText = prize && prize.code ? prize.code : 'Pending spin';
      const answersText = answerLines()
        .map((line, i) => `${i + 1}. ${line}`)
        .join('\n');
      const stamped = new Date().toISOString();

      const text = [
        'Wellness Scan — all customer data',
        '',
        `Coupon code: ${couponText}`,
        `Reward: ${prizeText}`,
        '',
        `Submitted: ${stamped}`,
        `Customer email: ${state.email}`,
        `Scan type: ${modeLabel(state.mode)}`,
        '',
        '--- Risk assessment ---',
        riskText || '• None',
        '',
        '--- Recommended products ---',
        recText || '• None',
        '',
        '--- Answers ---',
        answersText || '• None',
      ].join('\n');

      const riskRows = risks
        .map((r) => {
          const who = r.who ? `<div style="font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:#6b6570;margin-bottom:4px;">${escapeHtml(r.who)}</div>` : '';
          const color = r.level === 'High' ? '#b91c1c' : r.level === 'Moderate' ? '#b45309' : '#15803d';
          return `<tr><td style="padding:12px 0;border-bottom:1px solid #e6e2d4;">${who}<div style="font-weight:600;color:#1a121c;">${escapeHtml(
            r.category
          )}</div><div style="font-size:13px;color:${color};margin:4px 0;">${escapeHtml(r.level)} Risk</div><div style="font-size:13px;color:#5c5660;line-height:1.5;">${escapeHtml(
            r.description
          )}</div></td></tr>`;
        })
        .join('');
      const recRows = recs
        .map((p) => {
          const url = absUrl(p.url);
          const sale = productSale(p);
          return `<tr><td style="padding:12px 0;border-bottom:1px solid #e6e2d4;"><div style="font-size:11px;letter-spacing:0.14em;text-transform:uppercase;color:#466e66;">${escapeHtml(
            p.brandName
          )}</div><div style="font-size:16px;color:#1a121c;margin:4px 0;">${escapeHtml(
            p.name.replace(/\n/g, ' ')
          )}</div><div style="font-size:13px;color:#5c5660;">${escapeHtml(sale.priceLabel)}${
            sale.mrpLabel
              ? ` <span style="text-decoration:line-through;color:#8a8490;">${escapeHtml(sale.mrpLabel)}</span>`
              : ''
          }</div><a href="${escapeHtml(
            url
          )}" style="color:#466e66;font-size:13px;">View product</a></td></tr>`;
        })
        .join('');
      const prizeBlock = prize
        ? `<div style="margin:24px 0;padding:20px;border-radius:16px;background:#1a121c;color:#e6e8dc;text-align:center;"><div style="font-size:12px;letter-spacing:0.16em;text-transform:uppercase;opacity:0.7;">Your code</div><div style="font-size:28px;letter-spacing:0.18em;margin:8px 0;">${escapeHtml(
            prize.code
          )}</div><div style="font-size:14px;">${escapeHtml(prize.label)}</div></div>`
        : '';

      const html = `<div style="margin:0;padding:0;background:#e9eada;font-family:Inter,Arial,sans-serif;color:#1a121c;">
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" style="background:#e9eada;"><tr><td style="padding:24px 12px;">
  <table role="presentation" width="600" cellspacing="0" cellpadding="0" style="max-width:600px;margin:0 auto;background:#f7f6ef;border:1px solid #d9d3c4;border-radius:16px;">
    <tr><td style="padding:28px 28px 8px;text-align:center;">
      <div style="font-size:12px;letter-spacing:0.18em;text-transform:uppercase;color:#466e66;">Wellness Scan</div>
      <h1 style="margin:8px 0 0;font-size:28px;font-weight:400;color:#1a121c;">${escapeHtml(
        t('report_title', 'Your Wellness Report')
      )}</h1>
      <p style="margin:8px 0 0;color:#5c5660;font-size:14px;">${escapeHtml(shop)} · ${escapeHtml(modeLabel(state.mode))}</p>
    </td></tr>
    <tr><td style="padding:8px 28px 8px;">${prizeBlock}</td></tr>
    <tr><td style="padding:8px 28px 4px;"><h2 style="margin:0;font-size:14px;letter-spacing:0.08em;text-transform:uppercase;">${escapeHtml(
      t('risk_heading', 'Risk Assessment')
    )}</h2></td></tr>
    <tr><td style="padding:0 28px;"><table role="presentation" width="100%">${riskRows || '<tr><td style="padding:12px 0;color:#5c5660;">No items</td></tr>'}</table></td></tr>
    <tr><td style="padding:20px 28px 4px;"><h2 style="margin:0;font-size:14px;letter-spacing:0.08em;text-transform:uppercase;">${escapeHtml(
      t('recs_heading', 'Recommended For You')
    )}</h2></td></tr>
    <tr><td style="padding:0 28px 8px;"><table role="presentation" width="100%">${recRows || '<tr><td style="padding:12px 0;color:#5c5660;">No items</td></tr>'}</table></td></tr>
    <tr><td style="padding:16px 28px 28px;font-size:12px;color:#8a8490;line-height:1.6;">${escapeHtml(
      t(
        'disclaimer',
        'This Wellness Scan provides general wellness guidance and is not a substitute for professional medical advice.'
      )
    )}</td></tr>
  </table>
  </td></tr></table>
</div>`;

      const customerText = [
        `${shop} Wellness Scan — Your Report`,
        '',
        `Coupon code: ${couponText}`,
        `Reward: ${prizeText}`,
        '',
        `Scan type: ${modeLabel(state.mode)}`,
        '',
        '--- Risk assessment ---',
        riskText || '• None',
        '',
        '--- Recommended products ---',
        recText || '• None',
        '',
        '--- Your answers ---',
        answersText || '• None',
      ].join('\n');

      return {
        shop,
        prize,
        text,
        customerText,
        html,
        answersText,
      };
    }

    function contactFormEl() {
      return root.querySelector('#WlQuizNotify');
    }

    function mailFrameEl() {
      return document.getElementById('WlQuizMailFrame');
    }

    function wireContactFormTarget(form) {
      const iframe = mailFrameEl();
      if (form && iframe) form.setAttribute('target', iframe.name);
    }

    function fillContactFields(report, nameValue, useCustomerCopy) {
      const form = contactFormEl();
      if (!form) return null;
      const nameInput = form.querySelector('[data-wl-mail-name]');
      const emailInput = form.querySelector('[data-wl-mail-email]');
      const phoneInput = form.querySelector('[data-wl-mail-phone]');
      const bodyInput = form.querySelector('[data-wl-mail-body]');
      if (nameInput) nameInput.value = nameValue || 'Wellness Scan';
      if (emailInput && state.email) emailInput.value = state.email;
      if (phoneInput) phoneInput.value = '';
      if (bodyInput) {
        bodyInput.value =
          useCustomerCopy && report && report.customerText ? report.customerText : (report && report.text) || '';
      }
      return form;
    }

    function parkContactForm() {
      const holder = root.querySelector('[data-wl-mail-holder]');
      const form = contactFormEl();
      if (holder && form && form.parentElement !== holder) holder.appendChild(form);
    }

    function restoreContactForm() {
      const mount = root.querySelector('[data-email-mount]');
      const form = contactFormEl();
      if (mount && form && form.parentElement !== mount) mount.appendChild(form);
      const btn = form && form.querySelector('[data-email-submit]');
      if (btn) {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-label') || t('email_button', 'Get My Results');
      }
    }

    function submitShopifyForm(form) {
      if (!form) return Promise.resolve();
      wireContactFormTarget(form);
      return new Promise((resolve) => {
        const iframe = mailFrameEl();
        let settled = false;
        const done = () => {
          if (settled) return;
          settled = true;
          if (iframe) iframe.removeEventListener('load', done);
          resolve();
        };
        if (iframe) iframe.addEventListener('load', done);
        try {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        } catch (err) {
          try {
            form.submit();
          } catch (err2) {
            done();
            return;
          }
        }
        window.setTimeout(done, 5000);
      });
    }

    function sendShopifyAdminMail(report, nameValue) {
      const mail = config.email || {};
      if (mail.enabled === false) return Promise.resolve();
      const form = fillContactFields(report, nameValue);
      if (!form) return Promise.resolve();
      return submitShopifyForm(form);
    }

    function fillCustomerForm(report, options) {
      const opts = options || {};
      const mail = config.email || {};
      const form = root.querySelector('#WlQuizCustomer');
      if (!form || !state.email) return null;

      const wantsMarketing = !!opts.marketing && mail.send_customer !== false;
      if (!wantsMarketing && mail.save_customer === false) return null;

      const { adultResult, kidsResult } = compute();
      const recs = [...new Map([...adultResult.recs, ...kidsResult.recs].map((p) => [p.id, p])).values()];
      const tags = ['wellness-scan'];
      if (state.mode === 'kids') tags.push('scan-kids');
      else if (state.mode === 'both') tags.push('scan-family');
      else tags.push('scan-adult');
      if (state.prize && state.prize.code) tags.push('prize-' + String(state.prize.code).replace(/[^A-Za-z0-9_-]/g, ''));
      recs.forEach((p) => {
        const slug = (p.slug || p.key || '').toLowerCase();
        if (slug) tags.push('rec-' + slug);
      });

      const summary = report ? report.customerText || report.text || '' : '';
      const tagsInput = form.querySelector('[data-wl-cust-tags]');
      const emailInput = form.querySelector('[data-wl-cust-email]');
      const firstInput = form.querySelector('[data-wl-cust-first]');
      const lastInput = form.querySelector('[data-wl-cust-last]');
      const marketingInput = form.querySelector('[data-wl-cust-marketing]');
      if (tagsInput) tagsInput.value = tags.join(', ');
      if (emailInput) emailInput.value = state.email;
      if (firstInput) firstInput.value = wantsMarketing ? summary.slice(0, 255) : '';
      if (lastInput) lastInput.value = wantsMarketing ? summary.slice(255, 510) : '';
      if (marketingInput) marketingInput.value = wantsMarketing ? 'true' : '';
      return form;
    }

    function saveShopifyCustomer(report) {
      const mail = config.email || {};
      if (mail.save_customer === false || !state.email || state.customerSaved) return Promise.resolve();
      state.customerSaved = true;
      const form = fillCustomerForm(report || buildEmailReport(), { marketing: false });
      if (!form) return Promise.resolve();
      return submitShopifyForm(form);
    }

    function sendCustomerReport(report) {
      const mail = config.email || {};
      if (mail.send_customer === false || !state.email || state.emailSent) return Promise.resolve();
      state.emailSent = true;
      state.customerSaved = true;
      const form = fillCustomerForm(report, { marketing: true });
      if (!form) return Promise.resolve();
      return submitShopifyForm(form);
    }

    function sendFollowupSaves() {
      if (state.followupSent || !state.email) return;
      state.followupSent = true;
      saveShopifyCustomer().catch((err) => {
        console.error('Wellness Scan customer save failed', err);
      });
    }

    function sendPrizeContact() {
      if (state.prizeContactSent || !state.email) return;
      state.prizeContactSent = true;
      parkContactForm();
      sendShopifyAdminMail(buildEmailReport(), 'Wellness Scan reward');
    }

    const screens = {
      landing: root.querySelector('[data-screen="landing"]'),
      bridge: root.querySelector('[data-screen="bridge"]'),
      quiz: root.querySelector('[data-screen="quiz"]'),
      email: root.querySelector('[data-screen="email"]'),
      spin: root.querySelector('[data-screen="spin"]'),
      results: root.querySelector('[data-screen="results"]'),
    };

    const state = {
      mode: null,
      step: 0,
      answers: {},
      email: '',
      prize: null,
      prizeIndex: null,
      hasSpun: false,
      submissionId: null,
      familyContinued: false,
      emailSent: false,
      emailScreenDone: false,
      customerSaved: false,
      prizeContactSent: false,
      followupSent: false,
      wheelDeg: 0,
      multiAdvanceTimer: null,
    };

    function questions() {
      if (state.mode === 'kids') return KIDS_Q;
      if (state.mode === 'both') return ADULT_Q.concat(KIDS_Q);
      return ADULT_Q;
    }

    function setImmersive(on) {
      document.body.classList.toggle('wl-quiz-immersive', on);
    }

    function show(name) {
      Object.keys(screens).forEach((key) => {
        if (screens[key]) screens[key].hidden = key !== name;
      });
      setImmersive(name !== 'landing' && name !== 'results');
      window.scrollTo({ top: 0, behavior: 'auto' });
    }

    function currentQuestion() {
      return questions()[state.step];
    }

    function isSelected(question, option) {
      const val = state.answers[question.id];
      if (question.multiSelect) return Array.isArray(val) && val.includes(option);
      return val === option;
    }

    function canNext() {
      const q = currentQuestion();
      if (!q) return false;
      const val = state.answers[q.id];
      return q.multiSelect ? Array.isArray(val) && val.length > 0 : !!val;
    }

    function updateOptionSelection() {
      const q = currentQuestion();
      if (!q) return;
      const multi = !!q.multiSelect;

      root.querySelectorAll('[data-option]').forEach((btn) => {
        const opt = btn.getAttribute('data-option');
        const on = isSelected(q, opt);
        btn.classList.toggle('is-on', on);
        const mark = btn.querySelector('.wl-quiz__mark');
        if (!mark) return;
        if (multi) {
          mark.innerHTML = on ? ICONS.check : '';
        } else {
          mark.innerHTML = on ? '<div class="wl-quiz__mark-dot"></div>' : '';
        }
      });

      const nextBtn = root.querySelector('[data-quiz-next]');
      if (nextBtn) {
        nextBtn.disabled = !canNext();
      }
    }

    function pickOption(option) {
      const q = currentQuestion();
      if (!q || state.spinning) return;
      if (q.multiSelect) {
        const cur = state.answers[q.id] || [];
        if (option === 'None') {
          state.answers[q.id] = ['None'];
        } else {
          const next = cur.filter((x) => x !== 'None');
          state.answers[q.id] = next.includes(option) ? next.filter((x) => x !== option) : next.concat(option);
        }
      } else {
        state.answers[q.id] = option;
      }
      updateOptionSelection();
    }

    function compute() {
      const empty = { recs: [], deficiencies: [] };
      const adultResult = state.mode !== 'kids' ? scoreAdult(state.answers, products, images) : empty;
      const kidsResult = state.mode !== 'adult' ? scoreKids(state.answers, products, images) : empty;
      return { adultResult, kidsResult };
    }

    function renderQuiz() {
      const list = questions();
      const q = list[state.step];
      if (!q) return;
      const multi = !!q.multiSelect;
      const isFirst = state.step === 0;
      const adultCount = ADULT_Q.length;
      const sectionLabel =
        state.mode === 'both'
          ? state.step < adultCount
            ? t('label_your', 'YOUR ASSESSMENT')
            : t('label_child', "YOUR CHILD'S ASSESSMENT")
          : t('label_your', 'YOUR ASSESSMENT');

      const dots = list
        .map((_, i) => {
          const cls = i < state.step ? 'is-done' : i === state.step ? 'is-current' : '';
          return `<div class="wl-quiz__dot ${cls}"></div>`;
        })
        .join('');

      const introHeading = t('intro_heading', 'Your Family Deserves');
      const introAccent = t('intro_accent', 'Better Wellness.');
      const introChip = t('intro_chip', 'Welloura.');
      const introSub = t('intro_sub', 'Ayurveda meets Modern Science.');
      const introEm = t('intro_em', 'In gummies.');
      const intro = isFirst
        ? `<div class="wl-quiz__intro">
            <h1 class="wl-quiz__intro-title">${escapeHtml(introHeading)}${
              introAccent ? ` <span>${escapeHtml(introAccent)}</span>` : ''
            }</h1>
            <p class="wl-quiz__intro-sub">${
              introChip ? `<span class="wl-quiz__chip">${escapeHtml(introChip)}</span> ` : ''
            }${escapeHtml(introSub)}${introEm ? ` <em>${escapeHtml(introEm)}</em>` : ''}</p>
          </div>`
        : '';

      const seeIf = t('see_if', 'See if Welloura is right for you.');
      const heading = isFirst
        ? `<p class="wl-quiz__see">${withBrand(seeIf)}</p>
           <p class="wl-quiz__see-q">${escapeHtml(q.question)}</p>`
        : `<p class="wl-quiz__meta">${escapeHtml(sectionLabel)} · ${state.step + 1}/${list.length}</p>
           <h2 class="wl-quiz__question">${escapeHtml(q.question)}</h2>
           ${
             multi
               ? `<p class="wl-quiz__hint">${escapeHtml(t('hint_multi', 'Select all that apply'))}</p>`
               : '<div class="wl-quiz__hint"></div>'
           }`;

      const options = q.options
        .map((opt, i) => {
          const on = isSelected(q, opt);
          const mark = multi
            ? `<div class="wl-quiz__mark wl-quiz__mark--check">${on ? ICONS.check : ''}</div>`
            : `<div class="wl-quiz__mark wl-quiz__mark--radio">${on ? '<div class="wl-quiz__mark-dot"></div>' : ''}</div>`;
          return `<button type="button" class="wl-quiz__option wl-quiz__fade-up${on ? ' is-on' : ''}" data-option="${escapeHtml(
            opt
          )}" style="animation-delay:${i * 0.04}s">
            <div class="wl-quiz__option-row">${mark}<span class="wl-quiz__option-label">${escapeHtml(opt)}</span></div>
          </button>`;
        })
        .join('');

      const backLabel = escapeHtml(t('back_label', 'Back'));
      const nextLabel =
        state.step === list.length - 1 ? t('results_next', 'See Results') : t('next_label', 'Next');
      const nextDisabled = canNext() ? '' : ' disabled';

      screens.quiz.querySelector('[data-quiz-body]').innerHTML = `
        <div class="wl-quiz__dots">${dots}</div>
        ${intro}
        <div class="wl-quiz__fade-up">
          ${heading}
          <div class="wl-quiz__options">${options}</div>
        </div>
        <div class="wl-quiz__nav">
          <button type="button" class="wl-quiz__back" data-quiz-back>
            ${ICONS.chevronLeft}
            ${backLabel}
          </button>
          <button type="button" class="wl-quiz__next" data-quiz-next${nextDisabled}>
            ${escapeHtml(nextLabel)} ${ICONS.chevronRight}
          </button>
        </div>
      `;

      show('quiz');
    }

    function goNext() {
      if (!canNext()) return;
      const list = questions();
      if (state.step < list.length - 1) {
        state.step += 1;
        if (state.mode === 'both' && state.step === ADULT_Q.length && !state.familyContinued) {
          show('bridge');
          return;
        }
        renderQuiz();
      } else {
        show('email');
      }
    }

    function goBack() {
      if (state.multiAdvanceTimer) {
        clearTimeout(state.multiAdvanceTimer);
        state.multiAdvanceTimer = null;
      }
      if (state.step > 0) {
        state.step -= 1;
        renderQuiz();
      } else {
        state.mode = null;
        show('landing');
      }
    }

    function startMode(mode) {
      state.mode = mode;
      state.step = 0;
      state.answers = {};
      state.familyContinued = false;
      state.prize = null;
      state.prizeIndex = null;
      state.hasSpun = false;
      state.email = '';
      state.submissionId = null;
      renderQuiz();
    }

    function renderWheel() {
      const slice = 360 / PRIZES.length;
      const conic = WHEEL_COLORS.map((color, i) => `${color} ${i * slice}deg ${(i + 1) * slice}deg`).join(', ');
      const labels = PRIZES.map((prize, i) => {
        return `<div class="wl-quiz__slice" style="transform:rotate(${i * slice + slice / 2}deg)">
          <span class="wl-quiz__slice-label">${escapeHtml(prize.label)}</span>
        </div>`;
      }).join('');
      const pegs = PRIZES.map(
        (_, i) =>
          `<span class="wl-quiz__peg" style="transform:rotate(${i * slice}deg)"><i></i></span>`
      ).join('');
      const dividers = PRIZES.map(
        (_, i) => `<span class="wl-quiz__divider" style="transform:rotate(${i * slice}deg)"></span>`
      ).join('');

      screens.spin.querySelector('[data-spin-body]').innerHTML = `
        <h2 class="wl-quiz__stage-title wl-quiz__stage-title--lg">${escapeHtml(t('spin_title', 'You earned a spin'))}</h2>
        <p class="wl-quiz__stage-text wl-quiz__stage-text--muted">${escapeHtml(
          t('spin_text', 'Unlock your exclusive Welloura reward')
        )}</p>
        <div class="wl-quiz__wheel-wrap" data-wheel-wrap>
          <div class="wl-quiz__wheel-glow"></div>
          <div class="wl-quiz__wheel-ring">
            <div class="wl-quiz__wheel-inner">
              <div class="wl-quiz__wheel-spin" data-wheel-spin style="transform:rotate(0deg)">
                <div class="wl-quiz__wheel-face" style="background:conic-gradient(from -90deg, ${conic})"></div>
                <div class="wl-quiz__wheel-shine" aria-hidden="true"></div>
                ${dividers}
                ${labels}
                ${pegs}
              </div>
            </div>
          </div>
          <div class="wl-quiz__pointer" data-wheel-pointer>
            <div class="wl-quiz__pointer-tri"></div>
            <div class="wl-quiz__pointer-dot"></div>
          </div>
          <button type="button" class="wl-quiz__hub" data-spin-hub aria-label="${escapeHtml(t('spin_hub', 'SPIN'))}">
            <span class="wl-quiz__hub-bg"></span>
            <span class="wl-quiz__hub-face">
              <span class="wl-quiz__hub-idle">
                <img src="${config.logo}" alt="Welloura">
                <span class="wl-quiz__hub-spin">${escapeHtml(t('spin_hub', 'SPIN'))}</span>
              </span>
              <span class="wl-quiz__hub-busy">${escapeHtml(t('spinning', 'SPINNING'))}</span>
            </span>
          </button>
        </div>
        <p class="wl-quiz__spin-note">${escapeHtml(
          t('spin_note', 'Tap the center to spin · One spin per Wellness Scan')
        )}</p>
      `;
      state.wheelDeg = 0;
      show('spin');
    }

    function runWheelAnimation(idx) {
      const el = screens.spin.querySelector('[data-wheel-spin]');
      const wrap = screens.spin.querySelector('[data-wheel-wrap]');
      const pointer = screens.spin.querySelector('[data-wheel-pointer]');
      if (!el) return Promise.resolve();

      const slice = 360 / PRIZES.length;
      const jitter = (Math.random() - 0.5) * slice * 0.55;
      const turns = 6 + Math.floor(Math.random() * 2);
      const from = state.wheelDeg || 0;
      const landing = 360 - (idx * slice + slice / 2) + jitter;
      const target = from + turns * 360 + ((landing - (from % 360) + 360) % 360);
      const duration = 5200;

      if (wrap) wrap.classList.add('is-spinning');
      if (pointer) pointer.classList.add('is-ticking');

      return new Promise((resolve) => {
        const finish = () => {
          state.wheelDeg = target;
          el.style.transform = `rotate(${target}deg)`;
          if (pointer) {
            pointer.classList.remove('is-ticking');
            pointer.classList.add('is-landed');
          }
          if (wrap) wrap.classList.remove('is-spinning');
          resolve();
        };

        if (typeof el.animate === 'function') {
          const anim = el.animate(
            [{ transform: `rotate(${from}deg)` }, { transform: `rotate(${target}deg)` }],
            {
              duration,
              easing: 'cubic-bezier(0.12, 0.7, 0.08, 1.02)',
              fill: 'forwards',
            }
          );
          anim.onfinish = finish;
        } else {
          el.style.transition = 'none';
          el.style.transform = `rotate(${from}deg)`;
          void el.offsetWidth;
          el.style.transition = `transform ${duration}ms cubic-bezier(0.12, 0.7, 0.08, 1.02)`;
          el.style.transform = `rotate(${target}deg)`;
          window.setTimeout(finish, duration);
        }
      });
    }

    function spinTheWheel() {
      const hub = screens.spin.querySelector('[data-spin-hub]');
      if (!hub || state.spinning || state.hasSpun) return;
      if (!state.email) {
        window.alert('Enter your email before spinning.');
        show('email');
        return;
      }

      state.spinning = true;
      hub.disabled = true;
      hub.classList.add('is-busy');

      const data = claimSpinPrize();
      state.hasSpun = true;
      const idx = data.prizeIndex;
      state.prizeIndex = idx;
      state.prize = {
        label: data.label,
        code: data.code,
        emoji: data.emoji,
        percent: data.percent,
      };
      runWheelAnimation(idx)
        .then(() => {
          state.spinning = false;
          if (state.submissionId && state.prize) {
            patchSubmission(state.submissionId, {
              discountCode: state.prize.code,
              discountLabel: state.prize.label,
              discountPercent: state.prize.percent,
            });
          }
          sendFollowupSaves();
          window.setTimeout(() => renderWin(state.prize), 700);
        })
        .catch((err) => {
          console.error('Wellness Scan spin failed', err);
          state.spinning = false;
          state.hasSpun = false;
          hub.disabled = false;
          hub.classList.remove('is-busy');
          window.alert(err.message || 'Spin failed. Please try again.');
        });
    }

    function renderWin(prize) {
      screens.spin.querySelector('[data-spin-body]').innerHTML = `
        <div class="wl-quiz__fade-up">
          <div class="wl-quiz__win-emoji">${prize.emoji || '✨'}</div>
          <h2 class="wl-quiz__stage-title wl-quiz__stage-title--lg">${escapeHtml(t('win_title', 'Congratulations'))}</h2>
          <p class="wl-quiz__stage-text">${escapeHtml(t('win_prefix', 'You won'))} <span style="color:hsl(64 28% 89%);font-weight:500">${escapeHtml(
            prize.label
          )}</span></p>
          <div class="wl-quiz__code-wrap">
            <div class="wl-quiz__code-glow"></div>
            <div class="wl-quiz__code-card">
              <p class="wl-quiz__code-kicker">${escapeHtml(t('code_kicker', 'Your Code'))}</p>
              <div class="wl-quiz__code-row">
                <span class="wl-quiz__code">${escapeHtml(prize.code)}</span>
                <button type="button" class="wl-quiz__copy-btn" data-copy-code>
                  ${ICONS.copy}<span>${escapeHtml(t('copy_label', 'Copy'))}</span>
                </button>
              </div>
              <p class="wl-quiz__code-note">${escapeHtml(
                t('code_note', 'Use at checkout · Valid for 7 days · One use only')
              )}</p>
            </div>
          </div>
          <button type="button" class="wl-quiz__dark-cta" data-see-results>${escapeHtml(
            t('see_report', 'See My Personalized Results →')
          )}</button>
        </div>
      `;
    }

    function productCard(p) {
      const sale = productSale(p);
      const mrpHtml = sale.mrpLabel ? `<span class="wl-quiz__mrp">${escapeHtml(sale.mrpLabel)}</span>` : '';
      const priceHtml = sale.priceLabel ? `<span class="wl-quiz__price">${escapeHtml(sale.priceLabel)}</span>` : '';
      const offHtml = sale.discount ? `<span class="wl-quiz__off">${escapeHtml(sale.discount)}</span>` : '';
      return `<a class="wl-quiz__pcard wl-quiz__pcard--${p.key}" href="${escapeHtml(p.url)}">
        <div class="wl-quiz__pcard-media">
          <img src="${escapeHtml(p.image)}" alt="${escapeHtml(p.name)}" loading="lazy" decoding="async" width="400" height="400">
        </div>
        <div class="wl-quiz__pcard-body">
          <p class="wl-quiz__pcard-brand">${escapeHtml(p.brandName)}</p>
          <h3 class="wl-quiz__pcard-name">${escapeHtml(p.name)}</h3>
          <p class="wl-quiz__pcard-sub">${escapeHtml(p.subtitle)}</p>
          <div class="wl-quiz__pcard-price">
            ${mrpHtml}
            ${priceHtml}
            ${offHtml}
          </div>
          <span class="wl-quiz__pcard-cta">${escapeHtml(t('view_label', 'View'))} ${ICONS.chevronRight}</span>
        </div>
      </a>`;
    }

    function riskCard(item, delay) {
      const colors = { Low: '#22c55e', Moderate: '#f59e0b', High: '#ef4444' };
      const width = (item.score / item.maxScore) * 100;
      return `<div class="wl-quiz__risk is-${item.level.toLowerCase()} wl-quiz__fade-up" style="animation-delay:${delay}s">
        <div class="wl-quiz__risk-img"><img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.category)}" loading="lazy" width="768" height="432"></div>
        <div class="wl-quiz__risk-body">
          ${item.section ? `<span class="wl-quiz__risk-who">${escapeHtml(item.section)}</span>` : ''}
          <div class="wl-quiz__risk-top">
            <span class="wl-quiz__risk-cat">${escapeHtml(item.category)}</span>
            <span class="wl-quiz__risk-badge">${escapeHtml(item.level)} Risk</span>
          </div>
          <div class="wl-quiz__bar"><div class="wl-quiz__bar-fill" style="width:${width}%;background:${colors[item.level]}"></div></div>
          <p class="wl-quiz__risk-desc">${escapeHtml(item.description)}</p>
        </div>
      </div>`;
    }

    function renderResults() {
      const { adultResult, kidsResult } = compute();
      const recs = [...new Map([...adultResult.recs, ...kidsResult.recs].map((p) => [p.id, p])).values()];
      const risks =
        state.mode === 'both'
          ? adultResult.deficiencies
              .map((d) => ({ ...d, section: t('section_you', 'You') }))
              .concat(kidsResult.deficiencies.map((d) => ({ ...d, section: t('section_child', 'Your Child') })))
          : adultResult.deficiencies.concat(kidsResult.deficiencies);

      const banner = state.prize
        ? `<div class="wl-quiz__banner"><div class="wl-quiz__banner-glow"><div class="wl-quiz__banner-pill">
            <span class="wl-quiz__banner-label">${escapeHtml(t('code_kicker', 'Your Code'))}</span>
            <span class="wl-quiz__banner-code">${escapeHtml(state.prize.code)}</span>
            <span class="wl-quiz__banner-meta">· ${escapeHtml(state.prize.label)}</span>
            <button type="button" class="wl-quiz__banner-copy" data-copy-code aria-label="${escapeHtml(
              t('copy_label', 'Copy')
            )}">${ICONS.copy} ${escapeHtml(t('copy_label', 'Copy'))}</button>
          </div></div></div>`
        : '';

      let recsHtml = '';
      if (state.mode === 'both') {
        recsHtml = `<div class="wl-quiz__recs-split">
          <div>
            <h3 class="wl-quiz__recs-sub">${ICONS.user} ${escapeHtml(t('recs_you', 'Your Products'))}</h3>
            <div class="wl-quiz__pcards wl-quiz__pcards--${adultResult.recs.length === 1 ? '1' : '2'}">${adultResult.recs
              .map(productCard)
              .join('')}</div>
          </div>
          <div>
            <h3 class="wl-quiz__recs-sub">${ICONS.baby} ${escapeHtml(t('recs_child', "Your Child's Products"))}</h3>
            <div class="wl-quiz__pcards wl-quiz__pcards--${kidsResult.recs.length === 1 ? '1' : '2'}">${kidsResult.recs
              .map(productCard)
              .join('')}</div>
          </div>
        </div>`;
      } else {
        const n = recs.length;
        const cls = n === 1 ? '1' : n === 2 ? '2' : n === 3 ? '3' : '4';
        recsHtml = `<div class="wl-quiz__pcards wl-quiz__pcards--${cls}">${recs.map(productCard).join('')}</div>`;
      }

      screens.results.innerHTML = `
        <div class="wl-quiz__results-inner">
          ${banner}
          <h1 class="wl-quiz__results-title">${escapeHtml(t('report_title', 'Your Wellness Report'))}</h1>
          <p class="wl-quiz__results-lead">${escapeHtml(
            t('report_lead', "Based on your Wellness Scan responses, here's your health assessment")
          )}</p>
          <div>
            <div class="wl-quiz__section-head">${ICONS.activity}<h2>${escapeHtml(
              t('risk_heading', 'Risk Assessment')
            )}</h2></div>
            <div class="wl-quiz__risks">${risks.map((d, i) => riskCard(d, i * 0.1)).join('')}</div>
          </div>
          <div class="wl-quiz__recs">
            <h2 class="wl-quiz__recs-title">${escapeHtml(t('recs_heading', 'Recommended For You'))}</h2>
            ${recsHtml}
          </div>
          <div class="wl-quiz__retake-wrap"><button type="button" class="wl-quiz__retake" data-retake>${escapeHtml(
            t('retake', 'Retake Scan')
          )}</button></div>
          <p class="wl-quiz__disclaimer">${escapeHtml(
            t(
              'disclaimer',
              'This Wellness Scan provides general wellness guidance and is not a substitute for professional medical advice.'
            )
          )}</p>
        </div>
      `;
      show('results');
    }

    function copyCode(btn) {
      if (!state.prize) return;
      navigator.clipboard.writeText(state.prize.code).then(() => {
        btn.classList.add('is-copied');
        btn.innerHTML = `${ICONS.check}<span>${escapeHtml(t('copied_label', 'Copied'))}</span>`;
        setTimeout(() => {
          btn.classList.remove('is-copied');
          if (btn.classList.contains('wl-quiz__banner-copy')) {
            btn.innerHTML = `${ICONS.copy} ${escapeHtml(t('copy_label', 'Copy'))}`;
          } else {
            btn.innerHTML = `${ICONS.copy}<span>${escapeHtml(t('copy_label', 'Copy'))}</span>`;
          }
        }, 1800);
      });
    }

    function resetAll() {
      if (state.multiAdvanceTimer) {
        clearTimeout(state.multiAdvanceTimer);
        state.multiAdvanceTimer = null;
      }
      state.mode = null;
      state.step = 0;
      state.answers = {};
      state.email = '';
      state.prize = null;
      state.prizeIndex = null;
      state.hasSpun = false;
      state.submissionId = null;
      state.familyContinued = false;
      state.spinning = false;
      state.emailSent = false;
      state.emailScreenDone = false;
      state.customerSaved = false;
      state.prizeContactSent = false;
      state.followupSent = false;
      state.wheelDeg = 0;
      restoreContactForm();
      const emailInput = screens.email.querySelector('[data-email-input]') || root.querySelector('[data-email-input]');
      if (emailInput) emailInput.value = '';
      show('landing');
    }

    root.addEventListener('click', (e) => {
      const modeBtn = e.target.closest('[data-mode]');
      if (modeBtn) {
        startMode(modeBtn.getAttribute('data-mode'));
        return;
      }
      const optionBtn = e.target.closest('[data-option]');
      if (optionBtn) {
        pickOption(optionBtn.getAttribute('data-option'));
        return;
      }
      if (e.target.closest('[data-quiz-back]')) {
        goBack();
        return;
      }
      if (e.target.closest('[data-quiz-next]')) {
        goNext();
        return;
      }
      if (e.target.closest('[data-bridge-continue]')) {
        state.familyContinued = true;
        renderQuiz();
        return;
      }
      const hub = e.target.closest('[data-spin-hub]');
      if (hub && !state.spinning && !state.hasSpun) {
        spinTheWheel();
        return;
      }
      const copyBtn = e.target.closest('[data-copy-code]');
      if (copyBtn) {
        copyCode(copyBtn);
        return;
      }
      if (e.target.closest('[data-see-results]')) {
        renderResults();
        return;
      }
      if (e.target.closest('[data-retake]')) {
        resetAll();
      }
    });

    const emailForm = root.querySelector('#WlQuizNotify');
    if (emailForm) {
      wireContactFormTarget(emailForm);
      emailForm.addEventListener(
        'submit',
        (e) => {
          const input = emailForm.querySelector('[data-email-input]');
          state.email = ((input && input.value) || '').trim();

          if (state.emailScreenDone) {
            fillContactFields(buildEmailReport(), 'Wellness Scan reward');
            return;
          }

          const mail = config.email || {};
          if (mail.enabled === false) e.preventDefault();

          // Prize/code is assigned when the customer spins the wheel.
          const nameValue = 'Wellness Scan';
          const report = buildEmailReport();
          const useCustomerCopy = mail.send_customer !== false;
          fillContactFields(report, nameValue, useCustomerCopy);
          wireContactFormTarget(emailForm);
          if (mail.send_customer !== false) {
            sendCustomerReport(report);
          } else if (mail.save_customer !== false) {
            saveShopifyCustomer(report);
          }

          try {
            const { adultResult, kidsResult } = compute();
            const skus = Array.from(new Set([...adultResult.recs, ...kidsResult.recs].map((p) => p.slug)));
            state.submissionId = saveSubmission({
              email: state.email,
              mode: state.mode,
              answers: state.answers,
              recommendedSkus: skus,
              discountCode: null,
              discountLabel: null,
            });
          } catch (err) {
            console.error('Failed to save quiz submission', err);
          }

          const proceed = () => {
            if (state.emailScreenDone) return;
            state.emailScreenDone = true;
            renderWheel();
          };

          const iframe = mailFrameEl();
          if (iframe) iframe.addEventListener('load', proceed, { once: true });
          window.setTimeout(proceed, mail.enabled === false ? 0 : 3500);
        },
        true
      );
    }

    const params = new URLSearchParams(window.location.search);
    const preset = params.get('mode');
    if (preset === 'adult' || preset === 'kids' || preset === 'both') {
      startMode(preset);
    } else {
      show('landing');
    }
  }

  function boot() {
    document.querySelectorAll('[data-wl-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const root = e.target.querySelector('[data-wl-quiz]');
      if (root) initQuiz(root);
    });
  }
})();
